export const OfficeAlternateEquipmentState = {
	url: '/alternate-equipment',
	title: 'Office Alternate Equipment',
	template: '<office-alternate-equipment-page></office-alternate-equipment-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeAlternateEquipmentPageMod" */
			'@Containers/office-alternate-equipment-page/office-alternate-equipment.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
